<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">竞价报名</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='type' :list='navlist' @datashow=tableshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div class="ml-border">

          <div v-for="(item, index) in tenders.TenderChild">
            <div>
              <div style="display: flex;padding: 10px;justify-content: space-between;">
                <p style=" font-weight: bold;">
                  {{ tenders.Title }} 合同包 {{ item[0].PackNum }}
                </p>
                <div style='color:#ff0000;padding-right: 50px;'>
                  <!-- <span  v-if="convertDateFromString(tenders.JEndTime) < new Date()">已过期不能报名</span>
                  <span  v-else-if="convertDateFromString(tenders.BEndTime) < new Date()">报名已截止</span> -->
                  <span  v-if="item[0].UploadFiles"> {{ item[0].Status == 0 ? '您已经报过名了, 未审核' : item[0].Status == -1 ? item[0].EnrollRemark : '报名成功'}}</span>
                  <!-- <el-button type="primary" @click="submit(item[0])" v-else >立即报名</el-button> -->
                </div>
              </div>
              <div style="padding:10px; color:#ff0000">
                <span  v-if="convertDateFromString(tenders.JEndTime) < new Date()">已过期不能上传资格文件</span>
                <span  v-else-if="convertDateFromString(tenders.BEndTime) < new Date()">上传资格文件已截止</span>                
                <span v-else>
                  资格文件：{{ item[0].UploadFiles }}  上传时间：{{ item[0].UploadFilesTime == '1900-01-01 00:00:00' ? '' : item[0].UploadFilesTime  }}
                  <!-- <el-upload class="upload-demo" action="/api/uploadfile/baoming" 
                    :on-remove="handleRemove" :on-success="(response,file,filelist)=> handleAvatarSuccess(item[0], response,file,filelist)" name="Files" :limit="1"
                    :file-list="fileList" accept = ".pdf,.zip,.rar">
                    <el-button size="small" type="primary">上传投标文件</el-button>
                    <div slot="tip" class="el-upload__tip" style="font-size: 14px;">(支持上传文件的格式：pdf|zip|rar，单个文件最大支持50M，超过请联系工作人员。)</div>
                  </el-upload> -->
                  <el-upload  class="upload-demo" v-if="!item[0].UploadFiles || item[0].Status != 1"
                    action="" 
                    ref="Pic_Upload_1"                    
                    :http-request ="(params) =>Pic_Upload_1(params,item[0],fileList)"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"    
                    name="Files"
                    accept = ".pdf,.zip,.rar"
                    :limit="1"
                    :file-list="fileList">
                  <el-button size="small" type="primary">上传资格文件</el-button>                  
                <div slot="tip" class="el-upload__tip">(支持上传文件的格式：pdf|zip|rar，单个文件最大支持350M，超过请联系工作人员。)</div>
              </el-upload>
                </span>
              </div>
            </div>


            <el-table :data="item" border style="font-size: 16px;" :row-style="{}" :cell-style="{ 'font-size': '14px' }"
              :header-row-style="{}" :fit="true">
              <el-table-column prop="Option" label="细项">
              </el-table-column>
              <el-table-column prop="Name" label="采购项目名称">
              </el-table-column>
              <el-table-column prop="Brand" label="品牌">
              </el-table-column>
              <el-table-column prop="Number" label="数量">
              </el-table-column>
              <el-table-column prop="Price" label="单价">
              </el-table-column>
              <el-table-column prop="TenderType" label="竞价类别">
              </el-table-column>
              <el-table-column prop="Unit" label="采购单位">
              </el-table-column>
              <el-table-column prop="StartPrice" label="竞价起标价">
              </el-table-column>
              <el-table-column prop="ModelSetting" label="型号及设置">
              </el-table-column>
              <el-table-column prop="Remark" label="备注" width="230px">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Enroll",
  components: { leftmenu, leftlogin },
  data: function () {
    return {
      type: 2,
      Id: 0,
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      tenders: {},
      form: {},
      fileList:[],
    };
  },
  updated() {
  },
  created() {
    var that = this;
    this.Id = this.$route.query.id;
    that.getData();
  },
  watch: {
    $route: async function (to, from) {

    }
  },
  mounted() {

  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/TenderChild/" + that.Id, null, r => {
        that.tenders = r.response;
      });
    },
    tableshow(item) {
      var that = this;
      if (item.Id == 1)
        that.$router.replace("/UserCenter");
      if (item.Id == 2)
        that.$router.replace("/Enroll");
      if (item.Id == 3)
        that.$router.replace("/Bidding");
      if (item.Id == 4)
        that.$router.replace("/BiddingHistory");
      return false;
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var date = new Date(dateString.replace(/-/g, "/"));
        return date;
      }
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
    },
    handleAvatarSuccess(UploadFiles,item){
      var that = this;
        that.$api.post("/Enroll/Post", {TenderId : that.Id, PackNum : item.PackNum, UploadFiles: UploadFiles }, data => {        
              if (data.success) {
                this.$notify({
                  type: "success",
                  message: "上传成功!",
                  duration: 3000
                });
                location.reload();                
              } else {
                this.$message({
                  type: "error",
                  message: data.msg,
                  showClose: true
                });
              }
      });
    },
    submit(item){
      var that = this;
      that.$api.post("/Enroll/Post", {TenderId : that.Id, PackNum : item.PackNum }, data => {        
              if (data.success) {
                this.$notify({
                  type: "success",
                  message: "报名成功!",
                  duration: 3000
                });
                location.reload();
              } else {
                this.$message({
                  type: "error",
                  message: data.msg,
                  showClose: true
                });
              }
      });
    },
    Pic_Upload_1(file,fromData, prop){
      this.importFile(file,fromData)      
    },
    //清空显示列表
    clearShowList (uid) {
        let idx = this.$refs['Pic_Upload_1'].uploadFiles.findIndex(item => item.uid === uid)
        this.$refs.Pic_Upload_1.uploadFiles.splice(idx, 1)
    },
    importFile (file,fromData) {      
      const isAccord = file.file.type === 'pdf' || file.file.type === 'zip' || file.file.type === 'rar';
      if (file.file.size / 1024 / 1024 > 350) {
        this.$message({
              showClose: true,
              message: "上传失败，文件大小请控制在 350M 以内",
              type: 'error'
            })
        this.clearShowList(file.uid);            
        return;
      }
      if (file.file.type == isAccord) {
        this.$message({
              showClose: true,
              message: "文件格式错误",
              type: 'error'
            })
            this.clearShowList(file.uid);            
            return;
      }
      var formData = new FormData()
      formData.append('files', file.file)
      var requestConfig = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$api.post("/uploadfile/baoming", formData, res =>{
          if (res.success) {
            this.handleAvatarSuccess(res.response,fromData)
            this.infoForm.Upload_1 = res.response
          } else {
            this.fileList = []
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error'
            })
            this.clearShowList(file.uid);
          }
        },requestConfig)
    }
  },
  computed: {

  }
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  width: 100%;
  border: 1px solid #CCCCCC;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.pagination {
  text-align: center;
}
</style>